/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Od`
};

const da_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Fra`
};

const de_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Ab`
};

const en_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Starting at`
};

const es_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Desde`
};

const fr_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `À partir de`
};

const hu_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Kezdve`
};

const it_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `A partire da`
};

const nl_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Vanaf`
};

const pl_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Od`
};

const pt_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `A partir de`
};

const sv_starting_at = /** @type {(inputs: {}) => string} */ () => {
	return `Från`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const starting_at = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.starting_at(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("starting_at", locale)
	if (locale === "cs") return cs_starting_at(inputs)
	if (locale === "da") return da_starting_at(inputs)
	if (locale === "de") return de_starting_at(inputs)
	if (locale === "en") return en_starting_at(inputs)
	if (locale === "es") return es_starting_at(inputs)
	if (locale === "fr") return fr_starting_at(inputs)
	if (locale === "hu") return hu_starting_at(inputs)
	if (locale === "it") return it_starting_at(inputs)
	if (locale === "nl") return nl_starting_at(inputs)
	if (locale === "pl") return pl_starting_at(inputs)
	if (locale === "pt") return pt_starting_at(inputs)
	return sv_starting_at(inputs)
};